import PropTypes from 'prop-types';
import FixedWidthTimeImpl from './fixed-width-time.js';
import MojitoCore from 'mojito/core';

const UIView = MojitoCore.Presentation.UIView;

/**
 * A view component that displays time in one, two, or three equally sized "boxes", dependent on the input.
 * <br>
 * For example, a typical time string '10:52:27' will be shown as '10', '52', and '27', separated
 * by component config `separator` value.
 * <br>
 * Using equally sized boxes prevents flickering in the dynamic time string display
 * caused by digits of varying width, such as '1' not being as wide as '0'.
 * <br>
 * Particularly useful for timers and clocks where the time is continuously updated.
 *
 * @class FixedWidthTime
 * @memberof Mojito.Presentation.Components
 */

/**
 * `FixedWidthTime` component prop types.
 *
 * @property {string} [time="00:00:00"] - One or more characters, separated by ":".
 * @property {string} [class] - Class name applied to the root element.
 *
 * @memberof Mojito.Presentation.Components.FixedWidthTime
 */
const propTypes = {
    time: PropTypes.string,
    class: PropTypes.string,
};

const defaultProps = {
    time: '00:00:00',
};

export default UIView('FixedWidthTime', FixedWidthTimeImpl, propTypes, defaultProps);
